import emma from '@/common/services/Emma'

const PlansResource = {
	getPlans () { return emma.get('api/plan') },
	getPlan (id) { return emma.get('api/plan/' + id) }
}

export default PlansResource



// WEBPACK FOOTER //
// ./src/common/resources/Plans.js